export default "__VITE_ASSET__CeIQwvHT__"